import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import TokenDevHero from "./TokenDevHero";
import CryptoCoin from "./CryptoCoin";
import TokenCreation from "./TokenCreation";
import BlockchainExpertise from "../../AMM DEX/BlockchainExpertise";
import UnlockThePotential from "./UnlockThePotential";
import WhyChooseXeer from "../../DeFi/DeFiStaking/WhyChooseXeer";

function TokenDevelopment() {
  return (
    <div>
      <Header />
      <TokenDevHero />
      <CryptoCoin />
      <TokenCreation />
      <UnlockThePotential />
      {/* <BlockchainExpertise /> */}
      <WhyChooseXeer />
      <Footer />
    </div>
  );
}

export default TokenDevelopment;
